import React from "react";

import { useHistory } from "react-router-dom";

import { Spinner } from "react-bootstrap";
import ReactPaginate from "react-paginate";

import {
  GridStyled,
  Wrapper,
  Itemheader,
  HeaderStyled,
  BodyTableStyled,
  CelTable,
  RowTable,
  PaginateStyled,
} from "./styled";
import { theme } from "../../styles/theme";

import { settings } from "../../../main/configs/settings";

export type ItemField = {
  title: string;
  key: string;
  size?: number;
  renderItem: (callback: any) => any;
  hide?: boolean;
};

export type DatgridProps = {
  routeToEdit?: string;
  fields: ItemField[];
  data: any[];
  changePage?: (ev: any) => void;
  onClickRow?: (ev: any) => void;
  totalPages: number;
  loading: boolean;
  shouldForcePage?: boolean;
  emptyMessage?: string;
};

const DataGrid: React.FC<DatgridProps> = ({
  fields,
  data,
  changePage,
  routeToEdit,
  totalPages,
  loading,
  onClickRow,
  shouldForcePage,
  emptyMessage = "Nenhum registro encontrado",
}) => {
  const history = useHistory();

  const handlePageClick = (event: any): void => {
    if (changePage) changePage(event.selected);
  };

  const goToEdit = (id: number): void => {
    if (routeToEdit) history.push(`${routeToEdit}${id}`);
  };

  const renderBody = (): JSX.Element => {
    if (loading) {
      return (
        <Spinner
          animation="grow"
          style={{ margin: "0 auto" }}
          variant="primary"
        />
      );
    }

    if (data.length === 0) {
      return (
        <div
          className="empty-grid"
          style={{
            padding: "24px",
            textAlign: "center",
            color: theme.colors.lightGray,
          }}
        >
          {emptyMessage}
        </div>
      );
    }

    return (
      <BodyTableStyled className="body-grid">
        {data.map((item, index) => (
          <RowTable
            className="row-grid"
            key={item.id}
            style={{
              color: (() => {
                if (item.status === "CANCELED") return theme.colors.red;
                if (item.status === "PENDING_CONFIRMATION") return "#FFA726";
                if (item.status === "EXPIRED") return theme.colors.gray500;
                return "white";
              })(),
            }}
            index={index}
            onClick={() => {
              if (onClickRow) onClickRow(item);
              if (routeToEdit) goToEdit(item.id);
            }}
          >
            {fields
              .filter((field) => !field.hide)
              .map((field) => {
                const cellContent = field.renderItem(item);
                return (
                  <CelTable
                    className="cel-grid"
                    key={field.key}
                    style={
                      field.size
                        ? { flex: `0 0 ${field.size}px`, minWidth: field.size, maxWidth: field.size }
                        : undefined
                    }
                  >
                    {cellContent}
                  </CelTable>
                );
              })}
          </RowTable>
        ))}
      </BodyTableStyled>
    );
  };

  return (
    <Wrapper className="data-grid">
      <GridStyled>
        <HeaderStyled className="header-grid">
          {fields
            .filter((field) => !field.hide)
            .map((field) => (
              <Itemheader
                key={field.key}
                className={`header-item header-${field.key}`}
                style={
                  field.size
                    ? { flex: `0 0 ${field.size}px`, minWidth: field.size, maxWidth: field.size }
                    : undefined
                }
              >
                {field.title}
              </Itemheader>
            ))}
        </HeaderStyled>
        {renderBody()}
        <PaginateStyled className="paginate">
          <ReactPaginate
            breakLabel="..."
            nextLabel=">"
            onPageChange={handlePageClick}
            pageRangeDisplayed={settings.perPage}
            pageCount={totalPages}
            previousLabel="<"
            nextClassName="next-button"
            prevClassName="prev-button"
            forcePage={shouldForcePage ? 0 : undefined}
          />
        </PaginateStyled>
      </GridStyled>
    </Wrapper>
  );
};

export default DataGrid;
